import {AfterViewChecked, ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {OVERVIEW_DATEPICKER_FORMATS} from "src/app/global/date-format";
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {HomeOrdersService} from "./home-orders.service";
import {i18nService} from "src/app/service-utils/i18n.service";
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {MatPaginator} from "@angular/material/paginator";
import {LanguagePickerService} from "src/app/utils/language-picker/language-picker.service";
import {HomeOrdersDialogComponent} from "./home-orders-dialog/home-orders-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {Article, OrderItem, OrderItemStatus, OrderQuery, OrderStatus} from "../../model/order/order";
import {LensOrderItem} from "../../model/order/order";
import {ReturnApiService} from "../../api/return-api.service";
import {Router} from "@angular/router";
import {ReturnStoreService} from "src/app/return/return-store.service";
import {LensConfigMode, LensSectionMode, LensSide} from "src/app/model/configuration/configuration";
import {NewOrderStoreService} from "src/app/new-order/new-order-store-service.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import * as moment from "moment";
import {NoopScrollStrategy} from "@angular/cdk/overlay";
import {switchMap} from "rxjs/operators";
import {TranslateService} from "@ngx-translate/core";
import {SortOrder} from "../../model/pagination/sort";

@Component({
  selector: 'app-home-orders',
  templateUrl: './home-orders.component.html',
  styleUrls: ['./home-orders.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: OVERVIEW_DATEPICKER_FORMATS},
  ],
})
export class HomeOverviewComponent implements OnInit, AfterViewChecked {
  originalItems: OrderItem[];
  items: MatTableDataSource<OrderItem>;
  selectedRows: LensOrderItem[] = []; //? is copyPossible(items) {check conditions}
  displayedColumns: string[] = ['checkbox', 'orderDate', 'count', 'side', 'article', 'commission', 'chargeNum', 'return', 'status', 'actions'];

  searchForm: FormGroup;

  hintKeys = ["", "home.orders.hints.twoSameSide", "home.orders.hints.threeSelected", "home.orders.hints.softSelected", "home.orders.hints.notCopyPossible", "home.orders.hints.seeFreeSelected", "home.orders.hints.loading"];
  hintMessage: string;
  hintIndex: number;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('overviewPaginator', {static: true}) overviewPaginator: MatPaginator;

  OrderStatus = OrderStatus;
  OrderItemStatus = OrderItemStatus;

  isLoading = false;
  startTime;
  endTime;

  constructor(
    private homeOrderService: HomeOrdersService,
    private i18nService: i18nService,
    private languagePickerService: LanguagePickerService,
    public dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private returnApi: ReturnApiService,
    private router: Router,
    private returnStoreService: ReturnStoreService,
    private newOrderStoreService: NewOrderStoreService,
    private formBuilder: FormBuilder,
    private dateAdapter: DateAdapter<Date>,
    private translateService: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.startTime = performance.now();
    //load small amount of recent items, so that customer can observe them instantly
    this.fetchOrders(true, 200);

    this.languagePickerService.currentLanguage$.subscribe(() => {
      if (this.languagePickerService.isEnglish()) {
        this.dateAdapter.setLocale('en')
      } else {
        this.dateAdapter.setLocale('de');
      }
    });

    this.searchForm = this.formBuilder.group({
      deliveryNmr: [''],
      commission: [''],
      chargeNum: [''],
      dateFrom: [''],
      dateTo: ['']
    });

    this.newOrderStoreService.sendOrder$.subscribe(() => {
      this.fetchOrders();
    });
  }

  public fetchOrders(isNeedSpinner = false, count?: number) {
    const items: number = count ? count : 11_000;
    this.isLoading = isNeedSpinner;
    this.homeOrderService.getHomeOrders({
      "count": items,
      "query": {},
      "startIndex": 0,
      "sortBy": {column: "orderId", order: SortOrder.DESC}
    }).subscribe(response => {
      this.originalItems = response.result;
      //console.log('this.originalItems', this.originalItems);
      // Temporary measure to exclude duplicates
      const filtered = response.result.filter(x =>
        !response.result.find(r =>
          r.orderItemId > x.orderItemId &&
          this.sameArticle(r.article, x.article) &&
          r.count == x.count &&
          r.erpOrderId == x.erpOrderId &&
          r.externalOrderId == x.externalOrderId &&
          r.position == x.position &&
          r.side == x.side &&
          r.orderDate.toDateString() == x.orderDate.toDateString() &&
          r.chargeNumber == x.chargeNumber
          //r.orderId == x.orderId &&
          //r.desireDate == x.desireDate &&
          //r.deliveryDate == x.deliveryDate &&
          //r.deliveryNumber == x.deliveryNumber &&
          //r.invoiceDate == x.invoiceDate &&
          //r.invoiceNumber == x.invoiceNumber &&
          //r.credit == x.credit &&
          //r.isReturn == x.isReturn &&
          //r.isIndividual == x.isIndividual
        )).sort((firstItem, secondItem) => {
        if (firstItem.orderDate < secondItem.orderDate) {
          return 1;
        }
        if (firstItem.orderDate > secondItem.orderDate) {
          return -1;
        }
        return 0;
      });
      //console.log('filtered', filtered);
      this.items = new MatTableDataSource(filtered);
      if (this.items != undefined) {
        this.createSortAndPagintaion();
      }
      this.isLoading = false;
      this.endTime = performance.now();
      console.log(`Call took ${this.endTime - this.startTime} milliseconds`);
    });
  }

  sameArticle(a, b: Article): boolean {
    if (a != null && b != null) {
      return a.name == b.name;
    } else {
      return a == b;
    }
  }

  ngAfterViewChecked() {
    this.hintMessage = this.hintKeys[this.hintIndex];
    this.cdRef.detectChanges();
  }

  getOrderDate(date: Date): string {
    return this.i18nService.toDateString(date);
  }

  isEnglish(): boolean {
    return this.languagePickerService.getLanguageCode() === 'en';
  }

  openInfoDialog(item: OrderItem): void {
    this.dialog.open(HomeOrdersDialogComponent, {
      width: '400px',
      data: {item: item},
      scrollStrategy: new NoopScrollStrategy()
    });
  }

  select(item: OrderItem) {
    let isPresent = false;
    if (this.selectedRows.length > 0) {
      for (let row of this.selectedRows) {
        if (item == row) {
          isPresent = true
        }
      }
    }
    if (isPresent) {
      this.selectedRows = this.selectedRows.filter(obj => obj !== item)
    } else {
      this.selectedRows.push(this.asLensItem(item));
    }
  }

  isNeedCheck(item: OrderItem) {
    return (this.selectedRows.findIndex(selectedRow => selectedRow.orderItemId === item.orderItemId) > -1) ? true : false;
  }

  print() {
    this.homeOrderService.downloadReport(this.selectedRows);
  }

  search(event: any) {
    event.preventDefault();

    let filterOrderItems: OrderItem[] = [];
    let numbers: string[] = [''];
    let query: OrderQuery = {};

    if (this.searchForm.get('deliveryNmr').value && this.searchForm.get('deliveryNmr').value !== '') {
      query.deliveryNumber = this.searchForm.get('deliveryNmr').value;
    }
    if (this.searchForm.get('commission').value && this.searchForm.get('commission').value !== '') {
      query.commission = this.searchForm.get('commission').value;
    }
    if (this.searchForm.get('dateFrom').value && this.searchForm.get('dateFrom').value !== '') {
      query.fromDate = this.searchForm.get('dateFrom').value;
    }
    if (this.searchForm.get('dateTo').value && this.searchForm.get('dateTo').value !== '') {
      query.toDate = this.searchForm.get('dateTo').value;
    }
    if (this.searchForm.get('chargeNum').value && this.searchForm.get('chargeNum').value !== '') {
      numbers = this.searchForm.get('chargeNum').value.replace(/ /g, '').split(',');
      query.chargeNumber = numbers[0];
    }

    if (query.deliveryNumber || query.commission || query.chargeNumber || query.fromDate || query.toDate) {
      this.startTime = performance.now();

      numbers.forEach(number => {
        if (number.length > 0) {
          query.chargeNumber = number;
        }
        this.homeOrderService.getHomeOrders({
          "count": 1_000,
          "query": query,
          "startIndex": 0,
          "sortBy": {column: "orderId", order: SortOrder.DESC}
        }).subscribe(response => {
          filterOrderItems = filterOrderItems.concat(response.result);
          filterOrderItems.sort((firstItem, secondItem) => {
            if (firstItem.orderDate < secondItem.orderDate) {
              return 1;
            }
            if (firstItem.orderDate > secondItem.orderDate) {
              return -1;
            }
            return 0;
          });
          this.items = new MatTableDataSource(filterOrderItems);
          if (this.items != undefined) {
            this.createSortAndPagintaion();
          }
          this.isLoading = false;
        });
      });

      this.endTime = performance.now();
      console.log(`Search Call took ${this.endTime - this.startTime} milliseconds`);
    } else {
      let filterOrderItems = this.originalItems;
      this.items = new MatTableDataSource(filterOrderItems);
      this.createSortAndPagintaion();
    }
  }

  createSortAndPagintaion() {
    this.items.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'article':
          return this.getArticle(item);
        default:
          return item[property];
      }
    };

    this.items.sort = this.sort;
    this.items.paginator = this.overviewPaginator;
  }

  asLensItem(item: OrderItem): LensOrderItem {
    return item as LensOrderItem;
  }

  isCopySelectedItems(items: Array<OrderItem>, isTrialLensCopy?: boolean): boolean {
    if (this.newOrderStoreService.finishedLoading == false) {
      this.hintIndex = 6;
      return false;
    }

    if (items == null) {
      return false;
    }

    if (items.length === 0) {
      this.hintIndex = 0;
      return false;
    }
    if (items.length >= 3) {
      this.hintIndex = 2;
      return false;
    }

    this.hintIndex = 0;
    let leftLensCount = 0;
    let rightLensCount = 0;


    for (let item of items) {
      if (item.article.type === 'LENS') {
        if (this.asLensItem(item).side === null) rightLensCount++;
        else if (this.asLensItem(item).side === 'RIGHT') rightLensCount++;
        else if (this.asLensItem(item).side === 'LEFT') leftLensCount++;
      }
    }
    if (leftLensCount > 1 || rightLensCount > 1) {
      this.hintIndex = 1;
      return false;
    }

    for (let item of items) {
      if (item.copyPossible === false || item.article.type !== 'LENS') {
        this.hintIndex = 4;
        return false;
      }
      if (isTrialLensCopy && item.article.lensType === 'SOFT') {
        this.hintIndex = 3;
        return false;
      }
      if (isTrialLensCopy && item.article.name.toLowerCase().includes('seefree')) {
        this.hintIndex = 5;
        return false;
      }
    }

    return true;
  }

  isReturn(items: OrderItem[]): boolean {
    if (items.length === 0) {
      return false;
    }
    if (items.length > 1) {
      return false;
    }
    for (let item of items) {
      if (item.chargeNumber != null && item.itemStatus != OrderItemStatus.RETURNED) {
        return true;
      }
    }
    return false;
  }

  pickLastNMonths(months: number) {
    this.searchForm.patchValue({
      dateFrom: moment().subtract(months, "months"),
      dateTo: moment(),
    });
  }

  copyFinalLens() {
    if (this.selectedRows.length === 2) {
      this.newOrderStoreService.setLensConfigMode(LensConfigMode.DUAL);
      this.newOrderStoreService.setLensSectionMode(LensSectionMode.FINAL_LENS);
      this.newOrderStoreService.setIsRightSideEnable(true);
      this.newOrderStoreService.setIsLeftSideEnable(true);
      if (this.selectedRows[0].side === LensSide.RIGHT) {
        this.selectedRows[1].commission = this.selectedRows[0].commission;
        this.newOrderStoreService.setCopyFinalLensRight(this.selectedRows[0]);
        this.newOrderStoreService.setCopyFinalLensLeft(this.selectedRows[1]);
      } else if (this.selectedRows[0].side === LensSide.LEFT) {
        this.selectedRows[0].commission = this.selectedRows[1].commission;
        this.newOrderStoreService.setCopyFinalLensRight(this.selectedRows[1]);
        this.newOrderStoreService.setCopyFinalLensLeft(this.selectedRows[0]);
      }
    } else {
      this.newOrderStoreService.setLensConfigMode(LensConfigMode.SINGLE);
      this.newOrderStoreService.setLensSectionMode(LensSectionMode.FINAL_LENS);
      if (this.selectedRows[0].side === LensSide.RIGHT) {
        this.newOrderStoreService.setIsRightSideEnable(true);
        this.newOrderStoreService.setIsLeftSideEnable(false);
        this.newOrderStoreService.setCopyFinalLensRight(this.selectedRows[0]);
      } else {
        this.newOrderStoreService.setIsLeftSideEnable(true);
        this.newOrderStoreService.setIsRightSideEnable(false);
        this.newOrderStoreService.setCopyFinalLensLeft(this.selectedRows[0]);
      }
    }
    this.router.navigate(['/new-order'], {fragment: 'final-lens'}).then(() => {
      document.getElementById('final-lens').scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    });
  }

  copyTrialLens() {
    if (this.selectedRows.length === 2) {
      this.newOrderStoreService.setLensConfigMode(LensConfigMode.DUAL);
      this.newOrderStoreService.setLensSectionMode(LensSectionMode.TRIAL_LENS);
      this.newOrderStoreService.setIsRightSideEnable(true);
      this.newOrderStoreService.setIsLeftSideEnable(true);
      if (this.selectedRows[0].side === LensSide.RIGHT) {
        this.selectedRows[1].commission = this.selectedRows[0].commission;
        this.newOrderStoreService.setCopyTrialLensRight(this.selectedRows[0]);
        this.newOrderStoreService.setCopyTrialLensLeft(this.selectedRows[1]);
      } else if (this.selectedRows[0].side === LensSide.LEFT) {
        this.selectedRows[0].commission = this.selectedRows[1].commission;
        this.newOrderStoreService.setCopyTrialLensRight(this.selectedRows[1]);
        this.newOrderStoreService.setCopyTrialLensLeft(this.selectedRows[0]);
      }
    } else {
      this.newOrderStoreService.setLensConfigMode(LensConfigMode.SINGLE);
      this.newOrderStoreService.setLensSectionMode(LensSectionMode.TRIAL_LENS);
      if (this.selectedRows[0].side === LensSide.RIGHT) {
        this.newOrderStoreService.setIsRightSideEnable(true);
        this.newOrderStoreService.setIsLeftSideEnable(false);
        this.newOrderStoreService.setCopyTrialLensRight(this.selectedRows[0]);
      } else {
        this.newOrderStoreService.setIsLeftSideEnable(true);
        this.newOrderStoreService.setIsRightSideEnable(false);
        this.newOrderStoreService.setCopyTrialLensLeft(this.selectedRows[0]);
      }
    }
    this.router.navigate(['/new-order'], {fragment: 'trial-lens'});
    setTimeout(() => {
      document.getElementById('trial-lens').scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
      this.newOrderStoreService.changeLensSectionMode(LensSectionMode.TRIAL_LENS);
    }, 50);
  }

  navigateReturn() {
    let item = this.selectedRows[0];
    this.returnStoreService.setItem(this.selectedRows[0]);
    if (item.side === LensSide.RIGHT) {
      this.returnStoreService.setIsRightSideEnable(true);
      this.returnStoreService.setIsLeftSideEnable(false);
    } else {
      this.returnStoreService.setIsLeftSideEnable(true);
      this.returnStoreService.setIsRightSideEnable(false);
    }
    this.router.navigate(['/return']);
  }

  getArticle(item: OrderItem) {
    return this.i18nService.getLensesDescriptionOverview(item);
  }

  getSide(item: any): string {
    return (item.side) ? item.side.charAt(0) : '';
  }

  getDeliveryTooltip(row: OrderItem) {
    let info: string;

    this.translateService.get("home.orders.tooltips.delivery").pipe(
      switchMap(text => {
        info = `${text}.\n`;
        return this.translateService.get("home.orders.tooltips.deliveryNumber").pipe(
          switchMap(text => {
            info = `${info} ${text} ${row.deliveryNumber}.\n`;
            return this.translateService.get("home.orders.tooltips.deliveryDate");
          })
        )
      })
    ).subscribe(text => {
      info = `${info} ${text} ${this.getOrderDate(row.deliveryDate)}.`;
    });

    return info;
  }

  getInvoiceTooltip(row: OrderItem) {
    let info: string;

    this.translateService.get("home.orders.tooltips.invoice").pipe(
      switchMap(text => {
        info = `${text}.\n`;
        return this.translateService.get("home.orders.tooltips.invoiceNumber").pipe(
          switchMap(text => {
            info = `${info} ${text} ${row.invoiceNumber}.\n`;
            return this.translateService.get("home.orders.tooltips.invoiceDate");
          })
        )
      })
    ).subscribe(text => {
      info = `${info} ${text} ${this.getOrderDate(row.invoiceDate)}.`;
    });

    return info;
  }

  getCreditRow(row: OrderItem) {
    let info: string;

    this.translateService.get("home.orders.tooltips.returned").pipe(
      switchMap(text => {
        info = `${text}.\n`;
        return this.translateService.get("home.orders.tooltips.credit")
      })
    ).subscribe(text => {
      info = `${info} ${text} ${row.credit}`;
    });

    return info;
  }
}
